import MediaViewer from "@/components/MediaViewer";

const REMOVAL_LABELS = { receipt: "receipt", id_front: "ID front", id_back: "ID back", window_notice: "signed notice" };

export function mediaItems(v) {
  const items = [];
  const tags = v.tag_photo_paths?.length ? v.tag_photo_paths : (v.tag_photo_path ? [v.tag_photo_path] : []);
  tags.forEach((p, i) => items.push({ path: p, label: `tag ${i + 1}` }));
  const boots = v.boot_photo_paths?.length ? v.boot_photo_paths : (v.boot_photo_path ? [v.boot_photo_path] : []);
  boots.forEach((p, i) => items.push({ path: p, label: `boot ${i + 1}` }));
  if (v.boot_video_path && !boots.includes(v.boot_video_path)) items.push({ path: v.boot_video_path, label: "boot video" });
  const rem = v.removal_photos && Object.keys(v.removal_photos).length ? v.removal_photos : (v.receipt_photo_path ? { receipt: v.receipt_photo_path } : {});
  Object.entries(REMOVAL_LABELS).forEach(([k, label]) => { if (rem[k]) items.push({ path: rem[k], label }); });
  (v.receipt_photo_paths || []).slice(1).forEach((p, i) => items.push({ path: p, label: `receipt ${i + 2}` }));
  (v.removal_extra_paths || []).forEach((p, i) => items.push({ path: p, label: `removal extra ${i + 1}` }));
  return items;
}

export default function EvidenceGallery({ v, className = "h-20", cols = "grid-cols-3", testId = "evidence" }) {
  const items = mediaItems(v);
  if (!items.length) return null;
  return (
    <div className={`grid ${cols} gap-2`} data-testid={`${testId}-gallery`}>
      {items.map((m, i) => <MediaViewer key={m.path + i} path={m.path} label={m.label} className={className} testId={`${testId}-${i}`} />)}
    </div>
  );
}
